import { isValidSlug } from './slug.js';
/** Minúsculas, sin puerto, sin punto final. */
export function normalizeHost(host) {
    if (!host)
        return '';
    let h = host.trim().toLowerCase();
    if (h.startsWith('[')) {
        const end = h.indexOf(']');
        return end > 0 ? h.slice(0, end + 1) : h;
    }
    const colon = h.indexOf(':');
    if (colon >= 0)
        h = h.slice(0, colon);
    return h.replace(/\.+$/, '');
}
function firstPathSegment(path) {
    const clean = (path || '/').split(/[?#]/)[0] ?? '';
    const seg = clean.split('/').find((s) => s.length > 0) ?? '';
    try {
        return decodeURIComponent(seg).toLowerCase();
    }
    catch {
        return seg.toLowerCase();
    }
}
/**
 * Decide qué menú mostrar según el host y el path:
 * 1. host === publicMenuHost → slug del primer segmento del path (`menu.yulab.dev/<slug>`).
 * 2. wildcardBase y host = `<slug>.<wildcardBase>` → slug del label.
 * 3. cualquier otro host → dominio propio del tenant (`by-host`).
 */
export function resolvePublicTarget(host, path, cfg) {
    const h = normalizeHost(host);
    if (!h)
        return { kind: 'none' };
    const menuHost = normalizeHost(cfg.publicMenuHost);
    if (menuHost && h === menuHost) {
        const slug = firstPathSegment(path);
        return isValidSlug(slug) ? { kind: 'slug', slug } : { kind: 'none' };
    }
    const base = normalizeHost(cfg.wildcardBase ?? '').replace(/^\*?\./, '');
    if (base) {
        if (h === base)
            return { kind: 'none' };
        if (h.endsWith(`.${base}`)) {
            const label = h.slice(0, -(base.length + 1));
            if (!label.includes('.') && isValidSlug(label))
                return { kind: 'slug', slug: label };
            return { kind: 'none' };
        }
    }
    return { kind: 'host', host: h };
}
/** URL pública default de un local: wildcard si está configurado, si no por path. */
export function buildPublicMenuUrl(slug, cfg) {
    const base = (cfg.wildcardBase ?? '').trim().replace(/^\*?\./, '');
    if (base)
        return `https://${slug}.${base}`;
    return `${cfg.publicMenuBaseUrl.replace(/\/+$/, '')}/${slug}`;
}
//# sourceMappingURL=public-url.js.map